import { render } from "./AppSelect.vue?vue&type=template&id=9fdc0c52&ts=true"
import script from "./AppSelect.vue?vue&type=script&lang=ts"
export * from "./AppSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__